import React, {Component} from 'react';

import Data from '../../data/Reviews.json';

class RandomReview extends Component {
    render () {

    	const reviews = Data.reviews;
    	const review = reviews[Math.floor(Math.random()*reviews.length)];
        return (
             <div className={ `random-review ${this.props.classes}` }>
                <i className="pe-icon pe-7s-star star-1"></i>
                <i className="pe-icon pe-7s-star star-2"></i>
                <i className="pe-icon pe-7s-star star-3"></i>
                <i className="pe-icon pe-7s-star star-4"></i>
                <i className="pe-icon pe-7s-star star-5"></i>
                <p>
				    {review.text}
				    <span>{review.client}</span>
  				</p>
            </div>
        );
    }
}

export default RandomReview


// WEBPACK FOOTER //
// ./src/components/RandomReview/RandomReview.js